const apiEnvironments = {
  local: {
    baseUrl: process.env.LOCAL_API_BASE_URL,
  },
  staging: {
    baseUrl: process.env.STAG_API_BASE_URL,
  },
  production: {
    baseUrl: process.env.PROD_API_BASE_URL,
  },
};

export const getApiUrlForEnvironment = (environment) => {
  if (!environment) {
    throw new Error("Environment must be specified");
  }

  const env = environment.toLowerCase();
  if (!apiEnvironments[env]) {
    throw new Error(
      `Unknown environment: ${environment}. Must be 'local', 'staging', or 'production'`
    );
  }

  return apiEnvironments[env].baseUrl;
};

export const getAvailableEnvironments = () => {
  return Object.keys(apiEnvironments);
};

export default apiEnvironments;
